<template>
  <div>
    <section-title content="Información Demográfica" :has-line="true" />
    <div class="p-3">
      <div class="mx-2">
        <div v-if="isReadOnly" class="px-2">
          <div v-if="isCSEE" class="row">
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Localización:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.locationType.name }}
                </p>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Centro:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.csee.center.name }}
                </p>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Municipio:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.csee.municipality.name }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="isSchool" class="row">
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Localización:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.locationType.name }}
                </p>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Región:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.school.region.name }}
                </p>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Municipio:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.school.municipality.name }}
                </p>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Escuela:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.school.locationSchool.name }}
                </p>
                <div v-if="canViewLocationName">
                  <span class="font-14 color-secondary-6">Nombre:</span>
                  <p class="font-16 font-weight-normal">
                    {{ model.school.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="isHome" class="row">
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Localización:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.locationType.name }}
                </p>
              </div>
            </div>
            <div
              v-for="(municipalityItem, idx) in model.home.municipalities"
              :key="`type-${idx}`"
              class="col-md-3 d-flex mt-2"
            >
              <div>
                <span class="font-14 color-secondary-6">
                  Municipio {{ idx + 1 }}:
                </span>
                <p class="font-16 font-weight-normal">
                  {{ municipalityItem.name }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="isProviderOffice" class="row">
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Localización:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.locationType.name }}
                </p>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">
                  Nombre del proveedor:
                </span>
                <p class="font-16 font-weight-normal">
                  {{ model.providerOffice.name }}
                </p>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div>
                <span class="font-14 color-secondary-6">Municipio:</span>
                <p class="font-16 font-weight-normal">
                  {{ model.providerOffice.municipality.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <label class="text-gray">Seleccione Localización:</label>
          <div class="d-flex align-items-center">
            <div
              v-for="(type, idx) in locationTypes"
              :key="`type-${idx}`"
              class="mr-4"
            >
              <action-button
                class="type-item px-3"
                :class="{
                  active: isTypeSelected(type.id),
                  'location-type-error': locationTypeError,
                }"
                @click="onSelectType(type)"
              >
                <img
                  class="location-type-icon"
                  :src="
                    isTypeSelected(type.id)
                      ? getIconByTypeSelectedId(type.id)
                      : getIconByTypeId(type.id)
                  "
                  @click.stop="onSelectType(type)"
                />
                {{ type.name }}
              </action-button>
            </div>
          </div>
          <div v-if="locationTypeError">
            <p class="pt-3 mb-0 home-error-text-color">
              <i class="fa fa-times-circle" />
              El tipo de localización es requerido.
            </p>
          </div>
          <hr v-if="!!model.locationType" class="my-4" />
          <div v-show="isCSEE">
            <div class="row">
              <div class="col-md-4">
                <validation-provider
                  v-slot="{ errors }"
                  name="lsdiCenter"
                  :rules="isCSEE ? 'required' : ''"
                >
                  <custom-drop-down
                    v-model="model.csee.center"
                    :custom-error-msg="'El CSEE es requerido.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Centro:"
                    :options="catalog.centers"
                    placeholder="Seleccione"
                    @input="onSelectCenter"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <custom-drop-down
                  v-model="model.csee.municipality"
                  :clearable="false"
                  :disabled="true"
                  fieldkey="id"
                  fieldname="name"
                  label="Municipio:"
                  :options="catalog.municipalities"
                  placeholder="Seleccione"
                />
              </div>
            </div>
          </div>
          <div v-show="isSchool">
            <div class="row">
              <div class="col-md-4">
                <validation-provider
                  v-slot="{ errors }"
                  name="lsdiRegion"
                  :rules="isSchool ? 'required' : ''"
                >
                  <custom-drop-down
                    v-model="model.school.region"
                    :custom-error-msg="'La región es requerida.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Región:"
                    :options="catalog.regions"
                    placeholder="Seleccione"
                    @input="onSelectRegion"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <validation-provider
                  v-slot="{ errors }"
                  name="lsdiMunicipio2"
                  :rules="isSchool ? 'required' : ''"
                >
                  <custom-drop-down
                    v-model="model.school.municipality"
                    :custom-error-msg="'El municipio es requerido.'"
                    :disabled="!model.school.region"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Municipio:"
                    :options="catalog.municipalities"
                    placeholder="Seleccione"
                    @input="onSelectMunicipality"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <validation-provider
                  v-slot="{ errors }"
                  name="lsdiSchool"
                  :rules="isSchool ? 'required' : ''"
                >
                  <custom-drop-down
                    v-model="model.school.locationSchool"
                    :custom-error-msg="'La escuela es requerida.'"
                    :disabled="!model.school.municipality"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Escuela:"
                    :options="catalog.schools"
                    placeholder="Seleccione"
                    @input="onSelectSchool"
                  />
                </validation-provider>
                <div class="mt-3">
                  <validation-provider
                    v-if="canViewLocationName"
                    v-slot="{ errors }"
                    name="lsdiSchoolName"
                    :rules="isSchool ? 'required' : ''"
                  >
                    <custom-input
                      v-model="model.school.name"
                      :custom-error-msg="'El nombre es requerido.'"
                      :error="errors[0]"
                      label="Nombre:"
                      placeholder="Escriba el nombre"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
          <div v-show="isHome">
            <div
              class="card mb-n5"
              :class="{
                'border-1 home-error-border': homeMunicipalitiesError,
                'border-0': !homeMunicipalitiesError,
              }"
            >
              <div class="card-header bg-gray-5 border-0 type-home-header">
                <i
                  class="
                    fas
                    fa-map-marker-alt fa-lg
                    bg-orange
                    p-2
                    rounded-circle
                    color-white
                  "
                />
                <span class="mx-3 font-weight-bold color-gray-7 font-20">
                  Municipio(s)
                </span>
              </div>
              <div class="card-body rounded">
                <icon-view
                  class="ml-3 rounded-circle"
                  icon="fas fa-plus"
                  icon-background="white"
                  icon-color="green"
                  icon-size="14px"
                  title="Añadir Municipio(s)"
                />
                <div class="p-3">
                  <multi-selection-picker
                    :all-items="catalog.municipalities"
                    id-prop-name="id"
                    item-type-name="municipio"
                    :modify-removes-item="true"
                    search-item-placeholder="Escriba aquí para buscar un municipio"
                    :selected-items="model.home.municipalities"
                    text-prop-name="name"
                  />
                  <div v-if="!!model.home.municipalities.length">
                    <hr class="mt-5" />
                    <label class="text-gray">
                      Municipio(s) Seleccionado(s)
                    </label>
                    <div>
                      <h4
                        v-for="(item, idx) in model.home.municipalities"
                        :key="`type-${idx}`"
                        class="d-inline mr-3"
                      >
                        <b-badge
                          class="
                            type-home-municipality-selected-badge
                            px-3
                            my-1
                          "
                          pill
                          variant="white"
                        >
                          {{ item.name }}
                          <i
                            class="
                              far
                              fa-times-circle
                              rounded-circle
                              color-red
                              ml-1
                              cursor-pointer
                            "
                            @click="quitMunicipality(idx)"
                          />
                        </b-badge>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="homeMunicipalitiesError">
              <p class="pt-3 mb-0 home-error-text-color">
                <i class="fa fa-times-circle" />
                Favor seleccione al menos un municipio.
              </p>
            </div>
          </div>
          <div v-show="isProviderOffice">
            <div class="row">
              <p />
              <div class="col-md-4">
                <validation-provider
                  v-slot="{ errors }"
                  name="lsdiProviderName"
                  :rules="isProviderOffice ? 'required' : ''"
                >
                  <custom-input
                    v-model="model.providerOffice.name"
                    :custom-error-msg="'El nombre del proveedor es requerido.'"
                    :error="errors[0]"
                    label="Nombre del proveedor:"
                    placeholder="Escriba el nombre del proveedor"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <validation-provider
                  v-slot="{ errors }"
                  name="lsdiMunicipality3"
                  :rules="isProviderOffice ? 'required' : ''"
                >
                  <custom-drop-down
                    v-model="model.providerOffice.municipality"
                    :custom-error-msg="'El municipio es requerido.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Municipio:"
                    :options="catalog.municipalities"
                    placeholder="Seleccione"
                    @input="onChangeMunicipality"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import MultiSelectionPicker from 'multi-selection-picker';
import IconView from 'icon-view';
import CodeLocationTypes from '@/utils/constants/codeLocationTypes';
import CseeIcon from '@/assets/img/shield-user-line.svg';
import CseeIconTrans from '@/assets/img/shield-user-line-trans.svg';
import SchoolIcon from '@/assets/img/bank-line.svg';
import SchoolIconTrans from '@/assets/img/bank-line-trans.svg';
import HomeIcon from '@/assets/img/home-4-line.svg';
import HomeIconTrans from '@/assets/img/home-4-line-trans.svg';
import ProviderOfficeIcon from '@/assets/img/building-line.svg';
import ProviderOfficeIconTrans from '@/assets/img/building-line-trans.svg';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import {
  getRegions as _getRegions,
  getMunicipalities as _getMunicipalities,
  getSchools as _getSchools,
  getCenters as _getCenters,
  getCenterAddress as _getCenterAddress,
  getLocationSchoolAddress as _getLocationSchoolAddress,
  getLocatioSchoolType as _getLocatioSchoolType,
} from '@/services/common/location.api';
import SchoolTypes from '@/utils/constants/schoolTypes';

export default {
  name: 'LocationServiceDemographicInfo',
  components: {
    SectionTitle,
    ActionButton,
    CustomDropDown,
    CustomInput,
    MultiSelectionPicker,
    IconView,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    locationTypes: {
      type: Array,
      default: () => [],
    },
    homeMunicipalities: {
      type: Array,
      default: () => [],
    },
    municipalities: {
      type: Array,
      default: () => [],
    },
    homeMunicipalitiesError: {
      type: Boolean,
      default: () => false,
    },
    locationTypeError: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    model: {
      locationType: null,
      csee: {
        center: null,
        municipality: null,
      },
      school: {
        region: null,
        municipality: null,
        locationSchool: null,
        name: null,
        schoolTypeId: null,
      },
      home: {
        municipalities: [],
      },
      providerOffice: {
        name: null,
        municipality: null,
      },
    },
    catalog: {
      regions: [],
      municipalities: [],
      schools: [],
      centers: [],
    },
  }),
  computed: {
    getIconByTypeId() {
      return (id) => {
        switch (id) {
          case CodeLocationTypes.School:
            return SchoolIcon;
          case CodeLocationTypes.CSEE:
            return CseeIcon;
          case CodeLocationTypes.Home:
            return HomeIcon;
          case CodeLocationTypes.ProviderOffice:
            return ProviderOfficeIcon;
        }
      };
    },
    getIconByTypeSelectedId() {
      return (id) => {
        switch (id) {
          case CodeLocationTypes.School:
            return SchoolIconTrans;
          case CodeLocationTypes.CSEE:
            return CseeIconTrans;
          case CodeLocationTypes.Home:
            return HomeIconTrans;
          case CodeLocationTypes.ProviderOffice:
            return ProviderOfficeIconTrans;
        }
      };
    },
    isTypeSelected() {
      return (id) => id === this.model.locationType?.id;
    },
    isCSEE() {
      return this.model.locationType?.id === CodeLocationTypes.CSEE;
    },
    isSchool() {
      return this.model.locationType?.id === CodeLocationTypes.School;
    },
    isHome() {
      return this.model.locationType?.id === CodeLocationTypes.Home;
    },
    isProviderOffice() {
      return this.model.locationType?.id === CodeLocationTypes.ProviderOffice;
    },
    isLocationTypeSelected() {
      return Boolean(this.model.locationType);
    },
    canViewLocationName() {
      const validTypes = [
        SchoolTypes.CareCenter,
        SchoolTypes.HeadStart,
        SchoolTypes.Home,
        SchoolTypes.PrivateSchool,
      ];

      return validTypes.includes(this.model.school.schoolTypeId);
    },
  },
  methods: {
    quitMunicipality(index) {
      this.model.home.municipalities.splice(index, 1);
    },
    async onSelectType(type) {
      this.$emit('on-selected-location-type', type);
      if (!this.isLocationTypeSelected) {
        await this.onSelectTypeHandler(type);
        return;
      }
      if (this.isTypeSelected(type.id)) return;
      const responseModal = await this.ShowCancelModal(
        'Confirmación',
        ' Al cambiar el Tipo de Localización, se eliminará toda la información documentada. ¿Está seguro que desea continuar con la actualización?',
        'Sí',
        'No'
      );
      if (!responseModal) return;
      this.clearModel();
      this.$emit('setPhysicalAddress', {});
      this.$emit('on-school-municipality', {});

      await this.onSelectTypeHandler(type);
    },
    async onSelectTypeHandler(type) {
      this.$emit('update:locationTypeError', false);
      this.model.locationType = type;
      switch (type.id) {
        case CodeLocationTypes.School:
          await this.getRegions();
          break;
        case CodeLocationTypes.CSEE:
          await this.getCenters();
          break;
        case CodeLocationTypes.Home:
          this.catalog.municipalities = [...this.homeMunicipalities];
          break;
        case CodeLocationTypes.ProviderOffice:
          this.catalog.municipalities = [...this.municipalities];
          break;
      }
    },
    async getRegions() {
      if (this.catalog.regions.length) return;
      const { data } = await _getRegions({
        academicYearId: this.currentAcademicYearId,
      });
      this.catalog.regions = data;
    },
    async getMunicipalities(regionId) {
      const { data } = await _getMunicipalities({
        academicYearId: this.currentAcademicYearId,
        regionId,
      });
      this.catalog.municipalities = data;
    },
    async getSchools(regionId, municipalityId) {
      const { data } = await _getSchools({
        academicYearId: this.currentAcademicYearId,
        regionId,
        municipalityId,
      });
      this.catalog.schools = data;
    },
    async getCenters() {
      if (this.catalog.centers.length) return;
      const { data } = await _getCenters({
        academicYearId: this.currentAcademicYearId,
      });
      this.catalog.centers = data;
    },
    async onSelectRegion(region) {
      this.model.school.municipality = null;
      this.model.school.locationSchool = null;
      this.$emit('setPhysicalAddress', {});
      this.$emit('on-school-municipality', {});

      if (!region) {
        this.catalog.municipalities = [];
        this.catalog.schools = [];
      } else {
        await this.getMunicipalities(region.id);
      }
    },
    async onSelectMunicipality(municipality) {
      this.model.school.locationSchool = null;
      this.$emit('setPhysicalAddress', {});
      this.$emit('on-school-municipality', {});
      if (!municipality) {
        this.catalog.schools = [];
      } else {
        await this.getSchools(this.model.school.region.id, municipality.id);
      }
    },
    async onSelectCenter(center) {
      if (!center) {
        this.model.csee.municipality = null;
        this.$emit('setPhysicalAddress', {});
        return;
      }
      const { data } = await _getCenterAddress(center.id);
      this.model.csee.municipality = this.municipalities.find(
        (x) => x.id === data.municipalityId
      );
      this.$emit('setPhysicalAddress', data);
    },
    async onSelectSchool(school) {
      let result = {};
      let municipality = this.model.school.municipality;
      if (school) {
        const { data } = await _getLocationSchoolAddress(
          school.id,
          this.currentAcademicYearId
        );
        result = {
          ...data,
          latitude: data.gpsLatitude,
          longitude: data.gpsLongitude,
        };
        delete result.gpsLatitude;
        delete result.gpsLongitude;

        const resultType = await _getLocatioSchoolType(school.id);

        this.model.school.schoolTypeId = resultType.data.id;
      } else {
        municipality = {};
      }
      this.$emit('setPhysicalAddress', result);
      this.$emit('on-school-municipality', municipality);
    },
    clearModel() {
      this.model = {
        locationType: null,
        csee: {
          center: null,
          municipality: null,
        },
        school: {
          region: null,
          municipality: null,
          locationSchool: null,
          name: null,
        },
        home: {
          municipalities: [],
        },
        providerOffice: {
          name: null,
          municipality: null,
        },
      };
    },
    onModelChange(val) {
      let result = { locationTypeId: val.locationType.id };
      switch (result.locationTypeId) {
        case CodeLocationTypes.CSEE:
          result.centerId = val.csee.center?.id;
          result.municipalityId = val.csee.municipality?.id;
          break;
        case CodeLocationTypes.School:
          result.regionId = val.school.region?.id;
          result.municipalityId = val.school.municipality?.id;
          result.locationSchoolId = val.school.locationSchool?.id;
          result.name = val.school.name;
          result.schoolTypeId = val.school.schoolTypeId;
          break;
        case CodeLocationTypes.Home:
          result.municipalities = val.home.municipalities.map((x) => x.id);
          if (this.homeMunicipalitiesError) {
            this.$emit(
              'update:homeMunicipalitiesError',
              result.municipalities.length === 0
            );
          }
          break;
        case CodeLocationTypes.ProviderOffice:
          result.providerName = val.providerOffice.name;
          result.municipalityId = val.providerOffice.municipality?.id;
          break;
      }
      this.$emit('input', result);
    },
    onValueChange(val) {
      if (
        this.isReadOnly &&
        val.locationTypeId !== this.model.locationType?.id
      ) {
        this.model.locationType = {
          id: val.locationTypeId,
          name: val.locationTypeName,
        };
        switch (val.locationTypeId) {
          case CodeLocationTypes.CSEE:
            this.model.csee = {
              center: {
                id: val.centerId,
                name: val.centerName,
              },
              municipality: {
                id: val.municipalityId,
                name: val.municipalityName,
              },
            };
            break;
          case CodeLocationTypes.School:
            this.model.school = {
              region: {
                id: val.regionId,
                name: val.regionName,
              },
              municipality: {
                id: val.municipalityId,
                name: val.municipalityName,
              },
              locationSchool: {
                id: val.locationSchoolId,
                name: val.locationSchoolName,
              },
              name: val.providerName,
              schoolTypeId: val.schoolTypeId,
            };
            break;
          case CodeLocationTypes.Home:
            this.model.home.municipalities = val.municipalities
              ? [...val.municipalities]
              : [];
            break;
          case CodeLocationTypes.ProviderOffice:
            this.model.providerOffice = {
              name: val.providerName,
              municipality: {
                id: val.municipalityId,
                name: val.municipalityName,
              },
            };
            break;
        }
      }
    },
    onChangeMunicipality(val) {
      this.$emit('on-select-municipality', val);
    },
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.onModelChange(val);
      },
    },
    value: {
      handler(val) {
        this.onValueChange(val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.type-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
}
.type-item.active {
  background-color: map-get($colors, 'green');
  color: map-get($colors, 'white');
}
.type-home-header > i {
  border: 5px solid;
}
.type-home-municipality-selected-badge {
  font-weight: 500 !important;
  border: 1px solid gray;
}
.location-type-icon {
  width: 25px;
  margin: 4px;
}
.home-error-border {
  border-color: map-get($colors, 'secondary-20') !important;
}
.home-error-text-color {
  color: map-get($colors, 'secondary-20');
}
.location-type-error {
  box-shadow: 0 0 0 0.2rem #ff5b5c69;
  color: map-get($colors, 'secondary-20') !important;
}
</style>
